<!--
 * @Author: 赵健
 * @Date: 2021-01-14 10:51:48
 * @LastEditTime: 2021-01-22 16:28:28
 * @LastEditors: 赵健
 * @Description: 修改描述
 * @FilePath: \trunk\src\App.vue
-->
<template>
  <div id="app" style="min-width: 1366px;">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
